module.exports = __webpack_public_path__ + "static/media/icon-open-account.8741c8c1.svg";